// extracted by mini-css-extract-plugin
export default {"slideUp":"ClearFilterButton_slideUp__z148a","slideDown":"ClearFilterButton_slideDown__Q-eSx"};